<template>
  <div class="wrap landing-page" :class="[lang]">
    <img src="@/assets/images/landing-logo.png" class="logo">
    <div class="title">
      <p class="top">{{$t('openAccount.t000114')}}<span>{{$t('openAccount.t000117')}}</span></p>
      <p class="sub">{{$t('openAccount.t000118')}}</p>
    </div>
    <div class="ewm-wrap">
      <img src="@/assets/images/landing-icon.png" class="icon">
      <div class="ewm-box">
        <div class="ewm-img">
          <img :src="ewmImg" class="ewm">
        </div>
        <p class="text">{{$t('openAccount.t000119')}}</p>
        <p class="sub">{{$t('openAccount.t000120')}}</p>
      </div>
    </div>
    <div class="step-box">
      <div class="item">
        <img src="@/assets/images/open-result-icon-step-01.png" class="icon1">
        <p class="text">{{$t('openAccount.t000121')}}</p>
        <span class="shape active"></span>
      </div>
      <div class="item">
        <img src="@/assets/images/open-result-icon-step-02.png" class="icon2">
        <p class="text">{{$t('openAccount.t000122')}}</p>
        <span class="shape active"></span>
      </div>
      <div class="item">
        <img src="@/assets/images/open-result-icon-step-03.png" class="icon3">
        <p class="text" >{{$t('openAccount.t000123')}}</p>
        <span class="shape active"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  data(){
    return{
      lang: '',
      ewmImg: ''
    }
  },
  created() {
    this.lang = localStorage.getItem('localLang');
    this.getEwmImg();
  },
  methods: {
    getEwmImg(){
      this.$apis.getEnum({
        key: 'openAccountLandingQr'
      }).then(res => {
        this.ewmImg = res[0].value
      })
    }
  }
};
</script>

<style scoped lang="less">
.landing-page.en{
  .title {
    .top{
      flex-direction: column;
      align-items: center;
      padding-left: 20px;
      span{
        margin-top: 10px;
        display: block;
      }
    }
    .sub{
      margin-top: 20px;
      line-height: 50px;
    }
  }
  .ewm-wrap{
    .ewm-box{
      .ewm-img{
        margin-top: 90px;
      }
    }
  }
}
.wrap{
  min-height: 100vh;
  background: url("../../../assets/images/landing-bg.png") no-repeat #17161C;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .logo{
    position: absolute;
    top: 45px;
    right: 56px;
    width: 72px;
    height: 82px;
  }
  .title{
    margin-top: 130px;
    color: #e1b395;
    background: linear-gradient(270deg,#e6cebf 0%, #e1b395 100%);
    -webkit-background-clip: text;
    //background-clip: text;
    -webkit-text-fill-color: transparent;
    //text-fill-color: transparent;
    .top{
      //display: flex;
      line-height: 1;
      font-size: 72px;
      //align-items: flex-end;
      //justify-content: center;
      text-align: center;
      letter-spacing: 2px;
      padding-right: 26px;
      font-weight: bold;
      span{
        font-size: 34px;
        font-weight: lighter;
        margin-left: 10px;
      }
    }
    .sub{
      margin-top: 5px;
      font-size: 46px;
      text-align: center;
      font-weight: 400;
    }
  }
  .ewm-wrap{
    margin: 138px auto 0;
    width: 636px;
    height: 622px;
    position: relative;
    .icon{
      position: absolute;
      right: 66px;
      top: -118px;
      width: 230px;
      height: 226px;
    }
    .ewm-box{
      height: 100%;
      background: url("../../../assets/images/landing-ewm-bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      z-index: 3;
      overflow: hidden;
      .ewm-img{
        width: 290px;
        height: 290px;
        margin: 110px auto 0;
        .ewm{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .text{
        margin-top: 25px;
        font-size: 38px;
        line-height: 52px;
        font-weight: 600;
        color: #17161C;
        text-align: center;
      }
      .sub{
        margin-top: 14px;
        text-align: center;
        color: #747377;
        font-size: 28px;
      }
    }
  }
  .step-box{
    margin-top: 54px;
    display: flex;
    position: relative;
    margin-bottom: 50px;
    .item{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 35px;
      justify-content: flex-end;
      position: relative;
      z-index: 3;
      .icon1{
        width: 70px;
        height: 52px;
      }
      .icon2{
        width: 68px;
        height: 62px;
      }
      .icon3{
        width: 56px;
        height: 62px;
      }
      .text{
        margin-top: 15px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
      }
      .shape{
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 24px;
        height: 24px;
        margin-left: -12px;
        background: url("../../../assets/images/open-result-icon-step-no.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 50%;
        &.active{
          background: url("../../../assets/images/open-result-icon-step-active.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    &:after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 11px;
      width: 100%;
      height: 1px;
      background: rgba(255,255,255,0.40);
    }
  }
}
</style>
